// =====================================================================
// MotDePasse.jsx — page PUBLIQUE /mot-de-passe#<jeton> : choisir un nouveau mot de passe (23-10-2026)
// =====================================================================
// Le jeton est dans le fragment (#) : le navigateur ne l'envoie jamais au serveur. La page le lit une fois, l'efface
// de la barre d'adresse (historique, capture d'écran), puis le renvoie dans le CORPS du POST. Lien valable 30 minutes,
// une seule fois ; un compte connecté ailleurs est déconnecté.
// =====================================================================
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth, errMsg } from '../services/api.js';
import { erreurMotDePasse, jetonDuFragment } from '../lib/motDePasse.js';
import PasswordStrengthHint from '../components/PasswordStrengthHint.jsx';
import CarteMotDePasse, { styles } from '../components/CarteMotDePasse.jsx';

export default function MotDePasse() {
  const [jeton] = useState(() => jetonDuFragment(window.location.hash));
  const [motDePasse, setMotDePasse] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [fait, setFait] = useState(false);

  // Le jeton ne reste pas dans la barre d'adresse ni dans l'historique.
  useEffect(() => {
    if (window.location.hash) window.history.replaceState(null, '', window.location.pathname);
  }, []);

  async function envoyer(e) {
    e.preventDefault();
    setErreur(null);
    if (motDePasse !== confirmation) { setErreur('Les deux mots de passe ne correspondent pas.'); return; }
    const faible = erreurMotDePasse(motDePasse);
    if (faible) { setErreur(faible); return; }
    setEnvoi(true);
    try {
      await auth.nouveauMotDePasse(jeton, motDePasse);
      setFait(true);
    } catch (err) {
      setErreur(errMsg(err));
    } finally {
      setEnvoi(false);
    }
  }

  if (!jeton) {
    return (
      <CarteMotDePasse titre="Lien incomplet">
        <p style={styles.texte}>
          Ce lien n'est pas complet. Ouvrez le lien directement depuis l'e-mail reçu, ou demandez-en un nouveau.
        </p>
        <Link to="/mot-de-passe-oublie" style={styles.lien}>Demander un nouveau lien</Link>
      </CarteMotDePasse>
    );
  }

  if (fait) {
    return (
      <CarteMotDePasse titre="Mot de passe changé">
        <div style={{ ...styles.succes, marginTop: 20 }}>Votre nouveau mot de passe est enregistré.</div>
        {/* Rechargement complet : une session ouverte sur ce poste vient d'être fermée par le serveur. */}
        <a href="/login" style={styles.lien}>Se connecter</a>
      </CarteMotDePasse>
    );
  }

  return (
    <CarteMotDePasse titre="Nouveau mot de passe">
      <p style={styles.texte}>Choisissez votre nouveau mot de passe Zeus.</p>
      <form onSubmit={envoyer}>
        <div style={{ marginBottom: 14 }}>
          <label style={styles.label} htmlFor="mdp">Nouveau mot de passe</label>
          <input id="mdp" type="password" required autoFocus autoComplete="new-password" value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)} style={styles.champ} />
          <PasswordStrengthHint password={motDePasse} />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={styles.label} htmlFor="mdp2">Confirmer le nouveau mot de passe</label>
          <input id="mdp2" type="password" required autoComplete="new-password" value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)} style={styles.champ} />
        </div>
        {erreur && <div style={styles.erreur}>{erreur}</div>}
        <button type="submit" disabled={envoi} style={styles.bouton(!envoi)}>
          {envoi ? 'Enregistrement…' : 'Enregistrer le mot de passe'}
        </button>
      </form>
      <Link to="/mot-de-passe-oublie" style={styles.lien}>Demander un nouveau lien</Link>
    </CarteMotDePasse>
  );
}
